import { VueConstructor } from 'vue'
import Router from 'vue-router'
import VueAppInsights from 'vue-application-insights'
import VueScrollTo from 'vue-scrollto'

export function installVue2UtilityPlugins(Vue: VueConstructor, router: Router) {
    if (process.env.APPINSIGHTS_INSTRUMENTATIONKEY) {
        Vue.use(VueAppInsights, {
            id: process.env.APPINSIGHTS_INSTRUMENTATIONKEY,
            router
        })
    }

    Vue.use(VueScrollTo, {
        container: 'body',
        duration: 500,
        easing: 'ease',
        offset: 0,
        force: true,
        cancelable: true,
        onStart: false,
        onDone: false,
        onCancel: false,
        x: false,
        y: true
    })
}
